import { CLIENT_EVENT, EventLogger } from "@app/config/loggers/eventLogger";
import { v4 as uuidv4 } from "uuid";
import { type DailyLogSearchConditions, countCodePoints } from "./dailyLogSearchState";

/**
 * 검색 계측의 안전한 요약. 검색어 원문·발췌·업체 이름·cursor는 절대 넣지 않는다 (TRD §9.2).
 */

export type SearchApplyTrigger = "typing" | "enter" | "clear" | "filter" | "remove" | "reset" | "fix_invalid";

const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";

export function getKeywordLengthBucket(keyword: string): "0" | "1-2" | "3-10" | "11-30" | "31+" {
  const length = countCodePoints(keyword);
  if (length === 0) return "0";
  if (length <= 2) return "1-2";
  if (length <= 10) return "3-10";
  if (length <= 30) return "11-30";
  return "31+";
}

export function countAppliedFilters(conditions: DailyLogSearchConditions): number {
  const hasDateRange = conditions.startDate !== null || conditions.endDate !== null;
  return (hasDateRange ? 1 : 0) + conditions.contractorIds.length + conditions.tagIds.length;
}

export function getSearchDevice(): "mobile" | "desktop" {
  return window.matchMedia?.(DESKTOP_MEDIA_QUERY).matches ? "desktop" : "mobile";
}

export function createSearchRequestId(): string {
  return uuidv4();
}

export function trackSearchApplied(
  projectId: number,
  conditions: DailyLogSearchConditions,
  trigger: SearchApplyTrigger,
) {
  EventLogger.track(CLIENT_EVENT.DAILY_LOG_SEARCH_APPLIED, {
    project_id: String(projectId),
    has_keyword: conditions.keyword !== "",
    keyword_length_bucket: getKeywordLengthBucket(conditions.keyword),
    filter_count: countAppliedFilters(conditions),
    trigger,
  });
}
